import React, { useRef, useState } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { Button, Col, Modal, ModalBody, ModalHeader, Row, Card, CardBody } from 'reactstrap';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { connect } from 'react-redux';
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import { GRL_URL } from 'src/utils/pnd/PndConstants';
import { isNumber, mobileNoFormat, mobileNoLength } from 'src/utils/validationUtils';

import renderField from 'src/shared/components/form/renderField';
import PersonIcon from '@mui/icons-material/Person';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import BadgeIcon from '@mui/icons-material/Badge';
import DomainIcon from '@mui/icons-material/Domain';
import MailIcon from '@mui/icons-material/Mail';
import LayersIcon from '@mui/icons-material/Layers';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import NotesIcon from '@mui/icons-material/Notes';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SaveIcon from '@mui/icons-material/Save';

const required = value => value ? undefined : 'Required';

const CustomerAddOrUpdate = ({ handleSubmit, setMapData, setMapInfo, address, status, dispatch, setLatitude, setLongitude, dataInfo }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isAddress, setAddress] = useState(null);
    const [apaIframeUrl] = useState(GRL_URL);
    const apaFrameRef = useRef(null);

    const handleFindLocation = () => {
        toggleModal();
        handleMessageToIframe();
    };

    const handleMessageToIframe = () => {
        if (dispatch) {
            dispatch(change('CustomerAddOrUpdateForm', 'buildingName', ""));
        }
        const datajson = '{"RequestID": ' + Math.floor((Math.random() * 20) + 1) + ',"MessageType":1,"AddressElements": [{"AddressElementTypeCode": 1,"Value":""},{"AddressElementTypeCode":2,"Value": ""},{ "AddressElementTypeCode": 3,"Value": ""},{"AddressElementTypeCode":4,"Value": ""},{"AddressElementTypeCode": 5,"Value":"520950"},{"AddressElementTypeCode": 6,"Value":"" },{"AddressElementTypeCode": 7, "Value": "" },{"AddressElementTypeCode": 8,"Value":""}]}';
        if (apaFrameRef.current) {
            apaFrameRef.current.contentWindow.postMessage(datajson, '*');
            window.addEventListener('message', handleMessageFromIframe);
        }
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    let deliveryAddress = "";
    const handleMessageFromIframe = (event) => {
        if (event && event.data) {
            try {
                const jsonRegex = /^\s*(\{.*\}|\[.*\])\s*$/;
                if (jsonRegex.test(event.data)) {
                    const data_from_apa = JSON.parse(event.data);
                    const buildingName = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 6);
                    const landmark = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 4);
                    const street = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 3);
                    const area = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 2);
                    const zone = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 7);
                    const city = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 8);
                    const emirates = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 1);
                    const latitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 10);
                    const longitude = data_from_apa.AddressElements.find(element => element.AddressElementTypeCode === 9);

                    if (buildingName && buildingName?.Value !== "") {
                        deliveryAddress = deliveryAddress + buildingName.Value + ",";
                        if (dispatch) {
                            dispatch(change('CustomerAddOrUpdateForm', 'buildingName', buildingName.Value));
                        }
                    }
                    if (buildingName?.Value === "" && landmark?.Value !== "") {
                        deliveryAddress = deliveryAddress + landmark.Value + ",";
                    }

                    if (street && street?.Value !== "") {
                        deliveryAddress = deliveryAddress + street.Value + ",";
                    }
                    if (area && area?.Value !== "") {
                        deliveryAddress = deliveryAddress + area.Value + ",";
                    }
                    if (zone && zone?.Value !== "") {
                        deliveryAddress = deliveryAddress + zone.Value + ",";
                    }
                    if (city && city?.Value !== "") {
                        deliveryAddress = deliveryAddress + city.Value + ",";
                    }
                    if (emirates && emirates?.Value !== "") {
                        deliveryAddress = deliveryAddress + emirates.Value;
                    }

                    const cleanAddress = deliveryAddress.replace(/,+/g, ',').replace(/^,|,$/g, '');
                    if (cleanAddress) {
                        setAddress(cleanAddress);
                        if (setMapData) {
                            setMapData(cleanAddress);
                        }
                    }
                    if (setLatitude && latitude) {
                        setLatitude(latitude?.Value);
                    }
                    if (setLongitude && longitude) {
                        setLongitude(longitude?.Value);
                    }
                    if (setMapInfo) {
                        setMapInfo(data_from_apa);
                    }
                    toggleModal();
                }
            } catch (error) {
                console.error('event.data is not a valid JSON string');
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} className="p-2 bg-light">
            <Col lg={12} md={12}>
                {/* Basic Information Section */}
                <Card className="border-0 shadow-sm mb-2">
                    <CardBody className="p-2">
                        <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                            <PersonIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                            <h6 className="m-0 fw-bold small text-uppercase">Basic Information</h6>
                        </div>
                        <Row className="g-2 mb-2">
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Customer Name <span className='text-danger'>*</span></label>
                                    <Field name="customerName" component={renderField} type="text" placeholder="Customer Name" validate={[required]} icon={PersonIcon} />
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Contact Name</label>
                                    <Field name="contactName" component={renderField} type="text" placeholder="Contact Name" icon={AccountCircleIcon} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="g-2 mb-2">
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mobile Number <span className='text-danger'>*</span></label>
                                    <Field name="mobileNo" component={renderField} type="text" placeholder="971xxxxxxx" validate={[required, mobileNoFormat, mobileNoLength]} icon={SmartphoneIcon} />
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Telephone No.</label>
                                    <Field name="telephoneNo" component={renderField} type="text" placeholder="04xxxxxxx" validate={isNumber} icon={LocalPhoneIcon} />
                                </div>
                            </Col>
                        </Row>
                        {dataInfo && (
                            <Row className="g-2 mb-2">
                                <Col lg={6} md={6}>
                                    <div className="mb-1">
                                        <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Customer Code <span className='text-danger'>*</span></label>
                                        <Field name="customerCode" component={renderField} type="text" placeholder="Customer Code" validate={[required]} disabled={true} icon={BadgeIcon} />
                                    </div>
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                </Card>

                {/* Address & Location Section */}
                <Card className="border-0 shadow-sm mb-2">
                    <CardBody className="p-2">
                        <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                            <LocationOnIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                            <h6 className="m-0 fw-bold small text-uppercase">Address & Location</h6>
                        </div>
                        <Row className="g-2 mb-2">
                            <Col md={12}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Customer Address <span className='text-danger'>*</span></label>
                                    <div className="input-group input-group-sm">
                                        <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                                            <LocationOnIcon style={{ fontSize: '1rem' }} />
                                        </span>
                                        <input
                                            className="form-control form-control-sm border-start-0"
                                            name="address"
                                            type="text"
                                            value={isAddress || address || ''}
                                            placeholder="Customer Address"
                                            readOnly
                                            style={{ fontSize: '0.85rem' }}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success"
                                            onClick={handleFindLocation}
                                            style={{ fontSize: '0.75rem', padding: '0.25rem 0.75rem' }}
                                        >
                                            <AddLocationAltIcon style={{ fontSize: '1rem' }} className="me-1" />
                                            Find Location
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="g-2 mb-2 mt-1">
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Building Name <span className='text-danger'>*</span></label>
                                    <Field name="buildingName" component={renderField} type="text" placeholder="Building Name" validate={[required]} icon={DomainIcon} />
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>PO Box No.</label>
                                    <Field name="poBoxNo" component={renderField} type="text" placeholder="PO Box No." validate={[isNumber]} icon={MailIcon} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="g-2">
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Floor Number <span className='text-danger'>*</span></label>
                                    <Field name="floorNo" component={renderField} type="text" placeholder="Floor Number" validate={[required]} icon={LayersIcon} />
                                </div>
                            </Col>
                            <Col lg={6} md={6}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Door Number <span className='text-danger'>*</span></label>
                                    <Field name="doorNo" component={renderField} type="text" placeholder="Door Number" validate={[required]} icon={MeetingRoomIcon} />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>

                {/* Additional Info Section */}
                <Card className="border-0 shadow-sm mb-2">
                    <CardBody className="p-2">
                        <Row className="g-2 align-items-center">
                            <Col lg={9} md={9}>
                                <div className="mb-1">
                                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Remarks</label>
                                    <Field name="faxNo" component={renderField} type="textarea" placeholder="Enter Remarks..." icon={NotesIcon} />
                                </div>
                            </Col>
                            <Col lg={3} md={3}>
                                <div className="mb-1 text-center font-weight-bold">
                                    <label className="form-label fw-bold text-muted small mb-1 d-block" style={{ fontSize: '0.7rem' }}>OPERATIONAL STATUS</label>
                                    <Field
                                        name="status"
                                        component={renderToggleButtonField}
                                        defaultChecked={status ? status : false}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>

            <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    className="px-4 py-1 rounded-pill shadow-sm d-flex align-items-center"
                    style={{ background: 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)', border: 'none', color: '#000', fontWeight: 'bold', fontSize: '0.85rem' }}
                >
                    <SaveIcon style={{ fontSize: '1rem' }} className="me-1" />
                    Submit
                </Button>
            </div>

            <Modal isOpen={isModalOpen} toggle={toggleModal} size="xl" style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={toggleModal}>
                    <div className="d-flex align-items-center">
                        <LocationOnIcon className="me-2 text-success" style={{ fontSize: '1.5rem' }} />
                        <b>Find Location</b>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <iframe ref={apaFrameRef} src={apaIframeUrl} width="100%" height="650px" title="Get Address" onLoad={handleMessageToIframe} style={{ border: 'none', borderRadius: '8px' }}></iframe>
                </ModalBody>
            </Modal>
        </form>
    );
};

const mapStateToProps = (state, data) => {
    if (data && data?.dataInfo) {
        return {
            initialValues: {
                customerId: data?.dataInfo?.customerId,
                customerName: data?.dataInfo?.customerName,
                customerCode: data?.dataInfo?.customerCode,
                mobileNo: data?.dataInfo?.mobileNo,
                buildingName: data?.dataInfo?.buildingName,
                mapInfo: data?.dataInfo?.mapInfo,
                address: data?.dataInfo?.address,
                telephoneNo: data?.dataInfo?.telephoneNo,
                contactName: data?.dataInfo?.contactName,
                floorNo: data?.dataInfo?.floorNo,
                doorNo: data?.dataInfo?.doorNo,
                poBoxNo: data?.dataInfo?.poBoxNo,
                faxNo: data?.dataInfo?.faxNo,
                status: data?.dataInfo?.status,
            }
        };
    }
    return {};
};

export default connect(mapStateToProps)(reduxForm({ form: 'CustomerAddOrUpdateForm', enableReinitialize: true })(CustomerAddOrUpdate));